const uniqueLessonsCount = (user) => new Set(user.completedLessons || []).size;
const hasLesson = (user, lessonId) => (user.completedLessons || []).includes(lessonId);

export const BADGES = [
  {
    id: 'geologist',
    name: 'جيولوجي صغير',
    nameEn: 'Little Geologist',
    description: 'أكمل درس الموارد المعدنية.',
    icon: '🪨',
    condition: (user) => hasLesson(user, 'lesson-1'),
    points: 50
  },
  {
    id: 'energy-expert',
    name: 'خبير الطاقة',
    nameEn: 'Energy Expert',
    description: 'أكمل درس مصادر الطاقة.',
    icon: '⚡',
    condition: (user) => hasLesson(user, 'lesson-2'),
    points: 50
  },
  {
    id: 'agriculture-genius',
    name: 'عبقري الزراعة',
    nameEn: 'Agriculture Genius',
    description: 'أكمل درس المياه والزراعة.',
    icon: '🌾',
    condition: (user) => hasLesson(user, 'lesson-3'),
    points: 50
  },
  {
    id: 'tourism-ambassador',
    name: 'سفير الاستكشاف',
    nameEn: 'Explorer Ambassador',
    description: 'تفاعل مع 10 مواقع على الخريطة.',
    icon: '🧭',
    condition: (user) => (user.mapInteractions || 0) >= 10,
    points: 30
  },
  {
    id: 'map-explorer',
    name: 'مستكشف الخريطة',
    nameEn: 'Map Explorer',
    description: 'تفاعل مع 20 موقعا على الخريطة.',
    icon: '🗺️',
    condition: (user) => (user.mapInteractions || 0) >= 20,
    points: 40
  },
  {
    id: 'game-champion',
    name: 'بطل الألعاب',
    nameEn: 'Game Champion',
    description: 'اربح 3 ألعاب تعليمية.',
    icon: '🎮',
    condition: (user) => (user.gamesWon || 0) >= 3,
    points: 40
  },
  {
    id: 'strong-will',
    name: 'العزيمة القوية',
    nameEn: 'Strong Will',
    description: 'حافظ على سلسلة تعلم لمدة 7 أيام.',
    icon: '🔥',
    condition: (user) => (user.streak || 0) >= 7,
    points: 60
  },
  {
    id: 'kunuz-expert',
    name: 'خبير كنوز مصر',
    nameEn: 'Kunuz Expert',
    description: 'أكمل جميع الدروس الأساسية (3 دروس).',
    icon: '🏆',
    condition: (user) => uniqueLessonsCount(user) >= 3,
    points: 100
  }
];

export const checkNewBadges = (user, earnedBadges) => {
  const newBadges = [];

  for (const badge of BADGES) {
    if (earnedBadges.includes(badge.id)) continue;
    if (badge.condition(user)) {
      newBadges.push(badge);
    }
  }

  return newBadges;
};
